import { render, staticRenderFns } from "./IssueReports.vue?vue&type=template&id=6026177b&scoped=true&"
import script from "./IssueReports.vue?vue&type=script&lang=js&"
export * from "./IssueReports.vue?vue&type=script&lang=js&"
import style0 from "./IssueReports.vue?vue&type=style&index=0&id=6026177b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026177b",
  null
  
)

export default component.exports